/* R&B · newsletter letter (snippets/rb-letter.liquid).
   When: after the cookie choice, once per visit, when the visitor has scrolled N % of the page and been on the site
   for M seconds (Theme settings → R&B · Newsletter letter). Never over an open menu, bag or drawer.
   Never for people already on the list: logged-in customers who accept marketing (Liquid), visitors Klaviyo has
   identified (they came from one of our emails or signed up before), and anyone who signed up in the footer or on a
   product page in this browser.
   Remembers (this browser): signed up → never again; no thanks / close → away for N days; shown → not again this visit.
   A/B (optional): A = scroll + time, B = time only. The variant goes with every event and into the Klaviyo source.
   Events: dataLayer.push({ event: 'rb_letter', rb_letter_action: shown | opened | dismissed | closed | signup | error, rb_letter_variant }).
   Links: ?rb_letter=1 shows the folder on any page (ignores everything above); ?rb_letter=open shows it and opens
   it straight onto the sign-up card (for Instagram bio and story links). */
(function () {
  var root = document.querySelector('[data-rb-letter]');
  if (!root || root.dataset.rbInit) return;
  root.dataset.rbInit = '1';

  var LS = 'rb_letter', SS = 'rb_letter_seen', T0 = 'rb_letter_t0';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var openNow = /[?&]rb_letter=open\b/.test(location.search);
  var force = openNow || /[?&]rb_letter=1\b/.test(location.search) || root.dataset.test === 'true';
  var cfg = {
    scroll: +root.dataset.scroll || 50, delay: +root.dataset.delay || 0, days: +root.dataset.days || 30,
    ab: root.dataset.ab === 'true', list: root.dataset.list, key: root.dataset.key
  };
  function get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } }
  function set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }

  // what this browser already said
  var state = {};
  try { state = JSON.parse(get(LS) || '{}') || {}; } catch (e) {}
  // already on the list: arrived from one of our emails (Klaviyo adds _kx), or just signed up in the footer form
  if (/[?&]_kx=/.test(location.search) || /utm_source=klaviyo/i.test(location.search)) { state.known = Date.now(); set(LS, JSON.stringify(state)); }
  if (/[?&]customer_posted=true/.test(location.search)) { state.signed = Date.now(); set(LS, JSON.stringify(state)); }
  if (!force) {
    if (state.signed || state.known) return;
    if (state.away && Date.now() < state.away) return;
    if (get(SS, true)) return;
  }
  var variant = 'A';
  if (cfg.ab) { variant = state.v || (Math.random() < .5 ? 'A' : 'B'); state.v = variant; set(LS, JSON.stringify(state)); }
  if (!get(T0, true)) set(T0, String(Date.now()), true);

  function track(action) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'rb_letter', rb_letter_action: action, rb_letter_variant: variant }); } catch (e) {}
  }
  function remember(patch) { for (var k in patch) state[k] = patch[k]; set(LS, JSON.stringify(state)); }

  // ---------------------------------------------------------------- when
  function consentPending() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function') return false;
      if (!cp.shouldShowBanner()) return false;
      var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
      return !c || (!c.marketing && !c.analytics && !c.preferences);
    } catch (e) { return false; }
  }
  function busy() {
    var b = document.body, de = document.documentElement;
    if (b.classList.contains('rbh-drawer-open') || b.classList.contains('overflow-hidden') || de.classList.contains('overflow-hidden')) return true;
    if (document.querySelector('cart-drawer.active, .drawer.active, details[open] > .menu-drawer, #support-sidebar:not(.support-sidebar--closed), .rb-loader.is-on')) return true;
    var form = document.activeElement && document.activeElement.closest && document.activeElement.closest('input, textarea, select');
    return !!form;
  }
  function scrolled() {
    var de = document.documentElement, max = de.scrollHeight - window.innerHeight;
    if (max < 200) return true; // short page: time decides
    return (window.scrollY / max) * 100 >= cfg.scroll;
  }
  function timeOk() { return Date.now() - (+get(T0, true) || Date.now()) >= cfg.delay * 1000; }
  var shown = false, known = false;
  function klaviyoKnows() {
    try {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') {
        Promise.resolve(k.isIdentified()).then(function (id) { if (id) { known = true; remember({ known: Date.now() }); } }).catch(function () {});
      }
    } catch (e) {}
  }
  function check() {
    if (shown || known) return;
    klaviyoKnows();
    if (consentPending() || busy()) return;
    if (!timeOk()) return;
    if (variant === 'A' && !scrolled()) return;
    show();
  }
  function start() {
    if (force) { setTimeout(function () { show(); if (openNow) setTimeout(open, reduce ? 0 : 700); }, openNow ? 600 : 1200); return; }
    window.addEventListener('scroll', throttle(check, 400), { passive: true });
    setInterval(check, 2000);
    document.addEventListener('visitorConsentCollected', function () { setTimeout(check, 1500); });
  }
  function throttle(fn, ms) { var t = 0; return function () { var n = Date.now(); if (n - t > ms) { t = n; fn(); } }; }

  // ---------------------------------------------------------------- the folder
  var form = root.querySelector('[data-rbnl-form]'), input = form.querySelector('input[type=email]'), msg = root.querySelector('[data-rbnl-msg]');
  var focusables = root.querySelectorAll('input, .rbnl__btn, .rbnl__go');
  function tabbable(on) { focusables.forEach(function (el) { el.tabIndex = on ? 0 : -1; }); }
  function cls(name) { root.classList.remove('is-tease', 'is-open', 'is-done', 'is-gone'); if (name) root.classList.add(name); }

  function show() {
    if (shown) return;
    shown = true;
    set(SS, '1', true);
    root.hidden = false;
    void root.offsetWidth;
    cls('is-tease');
    track('shown');
    // one breath: the card lifts a little out of the pocket and settles (sooner on touch screens, which have no hover)
    if (!reduce) {
      var touch = window.matchMedia('(hover: none)').matches;
      setTimeout(function () {
        if (!root.classList.contains('is-tease')) return;
        root.classList.add('is-breath');
        setTimeout(function () { root.classList.remove('is-breath'); }, 1900);
      }, touch ? 4000 : 9500);
    }
  }
  function open() {
    root.classList.add('was-open');
    cls('is-open');
    track('opened');
    tabbable(true);
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 1600);
  }
  function away(action) {
    if (root.classList.contains('is-done')) return;
    remember({ away: Date.now() + cfg.days * 864e5 });
    track(action);
    tabbable(false);
    cls('is-gone');
    setTimeout(function () { root.hidden = true; }, reduce ? 50 : 650);
  }
  root.querySelector('[data-rbnl-open]').addEventListener('click', open);
  root.querySelector('[data-rbnl-no]').addEventListener('click', function (e) { e.stopPropagation(); away(root.classList.contains('is-open') ? 'closed' : 'dismissed'); });
  root.querySelectorAll('[data-rbnl-close]').forEach(function (el) { el.addEventListener('click', function () { away('closed'); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden && root.classList.contains('is-open')) away('closed'); });

  // ---------------------------------------------------------------- sign up
  var body = root.dataset.body;
  function say(text, err) { msg.textContent = text; msg.classList.toggle('is-err', !!err); }
  input.addEventListener('input', function () { input.removeAttribute('aria-invalid'); if (msg.classList.contains('is-err')) say(body); });
  function subscribe(email) {
    var source = 'Website · Letter folder' + (cfg.ab ? ' (' + variant + ')' : '');
    if (cfg.key && cfg.list) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email, properties: { rb_letter_variant: variant } } } }
        }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); });
    }
    // no Klaviyo list set: Shopify customer (accepts marketing, tag newsletter)
    var fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓');
    fd.append('contact[email]', email); fd.append('contact[tags]', 'newsletter,letter-folder');
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'contact', { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok || /challenge/.test(r.url)) throw new Error('challenge'); });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { input.setAttribute('aria-invalid', 'true'); say(root.dataset.errEmail, true); input.focus(); return; }
    root.classList.add('is-busy');
    subscribe(email).then(function () {
      root.classList.remove('is-busy');
      remember({ signed: Date.now() });
      track('signup');
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (x) {}
      tabbable(false);
      try { input.blur(); } catch (x) {}
      cls('is-done');
      setTimeout(function () { root.hidden = true; }, reduce ? 4000 : 7000);
    }).catch(function () {
      root.classList.remove('is-busy');
      say(root.dataset.errSend, true);
      track('error');
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
